'use strict';

import { baseIframeUrl, shareBaseUrl } from 'config';

export default window === window.top ? shareBaseUrl : baseIframeUrl;
